import { c as _c } from "react/compiler-runtime";
import { PassengerCountInitialValuesType } from "@website/accommodation-ui/villa-search/villa-search-panel/villa-search-panel.types";
import { numberConvert } from "@website/utils/number-convert";
import { useRouter } from "next/router";
import { useState } from "react";
export const usePassengerCount = t0 => {
  const $ = _c(24);
  const {
    initialValues,
    searchType
  } = t0;
  const router = useRouter();
  const t1 = initialValues?.adult || 0;
  const t2 = initialValues?.child || 0;
  const t3 = initialValues?.room || 1;
  let t4;
  if ($[0] !== t1 || $[1] !== t2 || $[2] !== t3) {
    t4 = {
      adult: t1,
      child: t2,
      room: t3
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const [temporaryPassengerCount, setTemporaryPassengerCount] = useState(t4);
  const [passengerCount, setPassengerCount] = useState(temporaryPassengerCount);
  const {
    adult,
    child,
    room
  } = temporaryPassengerCount;
  const total = (adult || 1) + child;
  const remain = 15 * room - total;
  const remainNotAdult = Math.min(remain, (adult || 1) * 12 - child);
  const adultMax = (adult || 1) + remain;
  const adultMin = Math.max(Math.ceil(child / 12), 1);
  const childMax = child + remainNotAdult;
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setTemporaryPassengerCount(state => {
        setPassengerCount(state);
        return state;
      });
    };
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  const onSubmitPassengerCount = t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = value => {
      setTemporaryPassengerCount(state_0 => ({
        ...state_0,
        adult: value
      }));
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const onChangeAdult = t6;
  let t7;
  if ($[6] !== adult || $[7] !== adultMax || $[8] !== adultMin || $[9] !== searchType) {
    t7 = searchType === "home" ? [{
      increaseDisabled: (adult || 1) >= adultMax,
      decreaseDisabled: (adult || 1) <= adultMin,
      title: "\u062A\u0639\u062F\u0627\u062F \u0646\u0641\u0631\u0627\u062A",
      subtitle: "",
      value: adult,
      onChange: onChangeAdult
    }] : [{
      increaseDisabled: (adult || 1) >= adultMax,
      decreaseDisabled: (adult || 1) <= adultMin,
      title: "\u062A\u0639\u062F\u0627\u062F \u0645\u0633\u0627\u0641\u0631",
      value: adult,
      onChange: onChangeAdult
    }];
    $[6] = adult;
    $[7] = adultMax;
    $[8] = adultMin;
    $[9] = searchType;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const list = t7;
  let t8;
  if ($[11] !== passengerCount.adult || $[12] !== passengerCount.child || $[13] !== router) {
    t8 = passengerCount.adult + passengerCount.child === 0 ? "\u062A\u0639\u062F\u0627\u062F \u0645\u0633\u0627\u0641\u0631" : `${numberConvert(passengerCount.adult + passengerCount.child, {
      locale: router.locale
    })} نفر`;
    $[11] = passengerCount.adult;
    $[12] = passengerCount.child;
    $[13] = router;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = (adult || 1) >= adultMax;
  const t10 = child >= childMax;
  const t11 = !(room * 15 >= total);
  let t12;
  if ($[15] !== t10 || $[16] !== t11 || $[17] !== t9) {
    t12 = {
      isPassengerDisabled: t9,
      isChildrenDisabled: t10,
      isSubmitDisabled: t11
    };
    $[15] = t10;
    $[16] = t11;
    $[17] = t9;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== list || $[20] !== passengerCount || $[21] !== t12 || $[22] !== t8) {
    t13 = {
      passengerCountTitle: "\u0645\u0633\u0627\u0641\u0631",
      passengerCountResult: t8,
      passengerCountList: list,
      passengerCount,
      onSubmitPassengerCount,
      passengerCountValidation: t12
    };
    $[19] = list;
    $[20] = passengerCount;
    $[21] = t12;
    $[22] = t8;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
};